import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ReportCounterPageRoutingModule } from './report-counter-routing.module';

import { ReportCounterPage } from './report-counter.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReportCounterPageRoutingModule
  ],
  declarations: [ReportCounterPage]
})
export class ReportCounterPageModule {}
